import React from "react";

class ErrorBoundary extends React.Component<
	{ children: React.ReactNode },
	{ hasError: boolean }
> {
	constructor(props: { children: React.ReactNode }) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: unknown) {
		console.error("Error caught in ErrorBoundary:", error);
		return { hasError: true };
	}

	componentDidCatch(error: unknown, errorInfo: unknown) {
		// Optionally log error info here
		console.error(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex min-h-screen flex-col items-center justify-center bg-white text-center">
					<h1 className="mb-4 text-4xl font-bold text-blue-700">
						Something went wrong
					</h1>
					<p className="mb-8 text-lg text-gray-700">
						Please try refreshing the page or come back later.
					</p>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
